import { useEffect, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import VerificationClientTable from '../../../../../components/table/VerificationClient.table'
import ConfirmModal from '../../../../../components/Modal/Confirm.modal';
import { faXmarkCircle, faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useParams } from 'react-router';
import AdminService from '../../../../../services/admin.service';
import toast from 'react-hot-toast';

export default function ExamVerificationClients() {
    const params = useParams();
    const [showCreateModal, setShowCreateModal] = useState<boolean>(false);
    const [verificationClients, setVerificationClients] = useState<any>();
    const [newEmail, setNewEmail] = useState<string>("");

    const getAllVerificationClients = async () => {
        await AdminService.getAllVerificationClients(params.examId).then((res) => {
            if (res.status === 200) {
                setVerificationClients(res.data.data.verificationClients);
            }
        });
    };

    const handleCreate = async () => {
        await AdminService.createVerificationClient(params.examId, { email: newEmail })
            .then((res) => {
                if (res.status === 200) {
                    toast.success("Verification client created successfully");
                    getAllVerificationClients();
                    setShowCreateModal(false);
                    setNewEmail("");
                }
            })
            .catch((err) => {
                toast.error(err?.response?.data || "Unable to create verification client");
            });
    };

    useEffect(() => {
        getAllVerificationClients();
    }, []);

    return (
        <>
            <div className="mt-3">
                <div className="d-flex justify-content-between align-items-center">
                    <p
                        style={{ fontSize: "18px", fontWeight: "bold" }}
                        className="mt-2"
                    >
                        Verification Clients
                    </p>
                    <Button
                        variant="outline-primary"
                        className="fw-bold"
                        size="sm"
                        onClick={() => setShowCreateModal(true)}
                    >
                        Create Verification Client
                    </Button>
                </div>
                <div>
                    <VerificationClientTable
                        verificationClients={verificationClients}
                        examId={params.examId}
                        reload={getAllVerificationClients}
                    />
                </div>
            </div>

            <ConfirmModal
                titleText={"Create Verification Client"}
                bodyText={
                    <>
                        <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="Enter email"
                                value={newEmail}
                                onChange={(e: any) => setNewEmail(e.target.value)}
                            />
                        </Form.Group>
                    </>
                }
                show={showCreateModal}
                onHide={() => setShowCreateModal(false)}
                button={[
                    {
                        label: (
                            <>
                                <FontAwesomeIcon icon={faXmarkCircle} /> Cancel
                            </>
                        ),
                        action: () => setShowCreateModal(false),
                        variant: "secondary",
                    },
                    {
                        label: (
                            <>
                                <FontAwesomeIcon icon={faCheck} /> Create
                            </>
                        ),
                        action: handleCreate,
                        variant: "success",
                    },
                ]}
            />
        </>
    )
}
